import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';

@Injectable()
export class AdviserService {

    constructor(
        private http: HttpClient,
        private bdbSessionStrgService: BdbSessionStrgService
    ) {}

    public updateClientAssociation(): Observable<any> {
        const clientDocumentType = this.bdbSessionStrgService.get('identityType');
        const clientDocumentNumber = this.bdbSessionStrgService.get('identityNumber');
        const adviserDocumentType = this.bdbSessionStrgService.get('sellerIdentityType');
        const adviserDocumentNumber = this.bdbSessionStrgService.get('sellerIdentityNumberLdap');
        return this.http.post<any>(environment.endpointAdviser + '/authentication/adviser/client-association', {
            documentType: adviserDocumentType,
            documentNumber: adviserDocumentNumber,
            clientDocumentType: clientDocumentType,
            clientDocumentNumber: clientDocumentNumber
        });
    }

    public isAuthAdviserEnabled() {
        const mediumTypesAdviserList = environment.mediumTypesAdviser.split(',');
        console.log('Medium types: ', mediumTypesAdviserList);
        const mediumType = String(this.bdbSessionStrgService.get('mediumType'));
        console.log('Medium type: ', mediumType);
        const isSelfManagement = this.bdbSessionStrgService.get('selfManagement') + '' === 'true';
        const validation = environment.enableAuthAdviser && mediumTypesAdviserList.includes(mediumType) && !isSelfManagement;
        console.log('Validation: ', validation);
        return validation;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/adviser.service.ts